<template>
    <div>
        <!-- ヘッダー -->
        <div class="mb-4">
            <h2 class="fw-bold text-success mb-1">
                <i class="fa-solid fa-folder-tree"></i>
                勘定科目マスタ
            </h2>
        </div>
        <div class="container" v-cloak>
            <div class="mb-3 text-end">
                <button class="btn btn-outline-primary" @click="editAccount()">
                    <span class="fa-solid fa-plus"></span> 新規作成
                </button>
            </div>
            <div v-for="v in accounts" :key="v.id" class="card mb-2">
                <div class="card-body" :class="{'opacity-50': v.deleted_at}">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-start">
                            <div class="me-4">
                                <button class="btn btn-outline-secondary me-2"
                                    @click="editAccount(v.id)"
                                    :disabled="v.deleted_at">
                                    <span class="fa-solid fa-pencil"></span>
                                </button>
                            </div>
                            <div class="me-4">
                                <div class="d-flex align-items-baseline">
                                    <span class="fs-5 fw-bold">
                                        <ruby>
                                            {{ v.name }}
                                            <rt>
                                                {{ v.kana }}
                                            </rt>
                                        </ruby>
                                    </span>
                                </div>
                                <span class="small">
                                    <span class="badge bg-secondary" data-bs-toggle="tooltip" title="会計システム連携用の科目コード">
                                        科目コード
                                    </span>
                                    <span class="ms-1">{{ v.code }}</span>
                                </span>
                            </div>
                            <div>
                                <span v-if="v.deleted_at" class="badge bg-danger ms-2">削除済</span>
                            </div>
                        </div>
                        <div>
                            <button class="btn ms-3"
                                @click="toggle(v)"
                                :class="{'btn-outline-danger': !v.deleted_at, 'btn-outline-success': v.deleted_at}">
                                <span class="fa-solid fa-trash-can" v-if="!v.deleted_at"> 削除</span>
                                <span class="fa-solid fa-rotate-right" v-else> 復帰</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- 編集モーダル -->
            <account-titles-editor
                :account_title_id="account_title_id"
                @saved="reload"
                @close="closeModal"
            />
        </div>
    </div>
</template>

<script>
import AccountTitlesEditor from './accountTitlesEditor.vue'
export default {
    components: { AccountTitlesEditor },
    data() {
        return {
            accounts: [],
            showModal: false,
            modals: [],
            account_title_id: null,
        }
    },
    methods: {
        reload() {
            axios.get('/api/master/account-titles').then(res => {
                this.accounts = res.data
            }).catch(err => {Alert.err(err)});
        },
        editAccount(id = null) {
            this.account_title_id = id;
            setTimeout(() => {
                this.modals['account-titles-editor'].show();
            });
        },
        closeModal(id) {
            this.modals[id]?.hide();
        },
        toggle(account) {
            let action = "削除";
            let dangerMode = true;
            let icon = "error";
            if (account.deleted_at) {
                action = "復帰";
                dangerMode = false;
                icon = "success";
            }
            swal({
                title: `勘定科目${action}`,
                text: `指定の勘定科目を${action}します。\nよろしいですか？`,
                icon: icon,
                dangerMode: dangerMode,
                buttons: ["キャンセル", action]
            }).then(confirm => {
                if (confirm) {
                    axios.post(`/api/master/account-titles/${account.id}/toggle`).then(res => {
                        Alert.msg(res.data);
                    }).catch(err => {
                        Alert.err(err.response);
                    }).finally(() => this.reload());
                }
            });
        },
    },
    mounted() {
        this.modals['account-titles-editor'] = new bootstrap.Modal(document.getElementById('account-titles-editor'));
        this.reload()
    }
}
</script>
